













































import { Component, mixins } from '@niknevis/vue-modules'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import QTable from 'quasar/src/components/table/QTable.js';
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import collect from 'collect.js'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import PanelContentCampaignTableRow
  from '@/modules/content-campaign/components/panel/table/PanelContentCampaignTableRow.vue'
import { ContentCampaignCollectionType } from '@/modules/content-campaign/models/content-campaign-collection.model'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { getContentCampaignColumns } from '@/modules/content-campaign/models/columns/content-campaign.column'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'کمپین های تولید محتوا',
    page_sub_header: 'در این بخش می‌توانید  کمپین‌های خود را مشاهده و مدیریت نمایید'
  },
  metaInfo: {
    title: 'کمپین های تولید محتوا'
  },
  components: { BaseButton, FilterRow, Confirm, Heading, Pagination, TesTable }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {

  constructor(private readonly routes: PanelContentCampaignRoute) {
    super()
  }

  @ProvideReactive()
  @Prop() campaigns!: ContentCampaignCollectionType

  private rowComponent = PanelContentCampaignTableRow

  private contentCampaignColumns: QTable['columns'] = getContentCampaignColumns(this.$q)

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      key: 'statuses',
      holder: 'همه وضعیت ها',
      typeMode: false,
      items: collect(this.campaigns.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت مقالات ها',
      key: 'item_statuses',
      holder: 'همه وضعیت ها',
      typeMode: false,
      items: collect(this.campaigns.item_statuses)
        .map((item, index) => ({
          value: index,
          label: item
        })).toArray()
    })
  ]

  updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  protected get model() {
    return this.campaigns
  }

}
